import { GrantsPermissions } from './grants.permissions';
import { GrantsRoles } from './grants.roles';

export const grantsMappings = {
  [GrantsPermissions.GET_ACCOUNT_GRANTS]: [GrantsRoles.ACCOUNT_GRANTS_VIEWER],
  [GrantsPermissions.MANAGE_ACCOUNT_GRANTS]: [
    GrantsRoles.ACCOUNT_GRANTS_MANAGER,
  ],
  [GrantsPermissions.MARK_GRANT_AS_PAID]: [GrantsRoles.GRANT_PAYMENT_MANAGER],
};
